
const BLDB_MAX_QUERY_LENGTH = 10000;
const BLDB_WARNING_ID = 'bldb-query-limit-warning';

function bldbShowQueryLengthWarning() {
  // SequenceServer's FASTA input is a textarea.
  const textarea = document.querySelector('textarea');
  if (!textarea || !document.body) return;

  let warning = document.getElementById(BLDB_WARNING_ID);

  // Keep the warning outside React's query form.
  if (!warning) {
    warning = document.createElement('div');
    warning.id = BLDB_WARNING_ID;
    warning.setAttribute('role', 'alert');
    warning.setAttribute('aria-live', 'polite');

    Object.assign(warning.style, {
      position: 'fixed',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: '99999',
      maxWidth: '720px',
      width: 'calc(100% - 48px)',
      padding: '16px 20px',
      border: '2px solid #b42318',
      borderRadius: '8px',
      backgroundColor: '#fff0ed',
      color: '#8b1e14',
      boxShadow: '0 4px 18px rgba(0,0,0,0.2)',
      fontSize: '15px',
      lineHeight: '1.5',
      textAlign: 'center'
    });

    document.body.appendChild(warning);
  }

  const count = textarea.value.length;

  if (count > BLDB_MAX_QUERY_LENGTH) {
    warning.textContent =
      `Query too long: ${count.toLocaleString()} characters. ` +
      `The maximum allowed is ${BLDB_MAX_QUERY_LENGTH.toLocaleString()} ` +
      'characters, including FASTA headers and line breaks. ' +
      'Please shorten your query before running BLAST.';

    warning.style.display = 'block';
  } else {
    warning.style.display = 'none';
  }
}

// Capture input changes without modifying React-controlled elements.
document.addEventListener('input', bldbShowQueryLengthWarning, true);
document.addEventListener('change', bldbShowQueryLengthWarning, true);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bldbShowQueryLengthWarning);
} else {
  bldbShowQueryLengthWarning();
}
